const FormContainer = ({ children }) => {
  return <div className="relative bg-white shadow-sm px-3 md:px-6 py-4 md:py-8 rounded-md flex flex-wrap justify-between w-full">{children}</div>;
};

export default FormContainer;
